// src/pages/SalesHistory.js
import React, { useState, useEffect } from "react";
import { Table, Spinner } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../config";

// Axios instance with Bearer token
const authAxios = axios.create({ baseURL: BASE_URL });
authAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken"); 
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const SalesHistory = () => {
  const { orderId } = useParams(); // get orderId from URL
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch order history or single order
  const fetchOrders = async () => {
    try {
      setLoading(true);
      let url = "/orders/history";
      const params = {};

      if (orderId) {
        params.id = orderId; // fetch single order by ID
      }

      const response = await authAxios.get(url, { params });

      if (response.data && response.data.data) {
        // If fetching single order, wrap it in an array for uniform mapping
        const dataArray = Array.isArray(response.data.data.data)
          ? response.data.data.data
          : [response.data.data];
        const mapped = dataArray.map((o) => ({
          ...o,
          poNumber: o.po_number || `PO-${o.id}`,
        }));
        setOrders(mapped);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("❌ Error fetching orders:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [orderId]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()} ${String(
      date.getHours()
    ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
  };

  return (
    <div className="container mt-4">
      <h3 className="text-center mb-3">
        {orderId ? `Order Details #${orderId}` : "Sales History"}
      </h3>

      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Order ID</th>
              <th>Branch</th>
              <th>Vendor</th>
              <th>Driver</th>
              <th>Customer</th>
              <th>Created At</th>
              <th>Updated At</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0 ? (
              orders.map((o, idx) => (
                <tr key={o.id}>
                  <td>{idx + 1}</td>
                  <td>
                    {orderId ? (
                      o.poNumber
                    ) : (
                      <Link to={`/SalesHistory/${o.id}`}>{o.poNumber}</Link>
                    )}
                  </td>
                  <td>{o.showroom_name || "-"}</td>
                  <td>{o.vendor?.name || "-"}</td>
                  <td>{o.driver?.name || "-"}</td>
                  <td>{o.customer?.name || "-"}</td>
                  <td>{formatDate(o.created_at)}</td>
                  <td>{formatDate(o.updated_at)}</td>
                  <td>{o.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default SalesHistory;
